import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';

import Lab115B from 'dc/Lab115B';
import Spa16 from 'dc/Spa16';
import ChStPrt9 from 'dc/ChStPrt9';
import ChStPrt10 from 'dc/ChStPrt10';
import { Wrapper, Header, NumberWrapper, StatsContainer } from './elements';
import { useText, useFormatNumber } from 'common/hooks';
import { toNumber } from 'utils/common';

const deps = {
  sectionKey: state.challenge.userCampaign.sectionKey,
  structure: state.challenge.campaign.structure,
  organisationName: state.challenge.campaign.organisation.name,
};

export function ParticipationInsights({
  sectionKey,
  structure,
  organisationName,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const formatNumber = useFormatNumber();

  if (!structure.participantCount) {
    return null;
  }

  return (
    <Wrapper>
      <Header
        title={t('challenge.ChaPaD24B.ChaStat5D.number_of_participants', {
          organisationName,
        })}
      />
      <NumberWrapper>
        <Lab115B
          icon={'icon-people'}
          label={t('challenge.ChaPaD24B.ChaStat5D.participants')}
          value={formatNumber(structure.participantCount)}
        />
      </NumberWrapper>
      <StatsContainer>
        <ChStPrt9
          challenge_participation_amount_text={t(
            'challenge.ChStPrt9.challenge_participation_amount',
            {
              participantCounts: formatNumber(structure.participantCount),
              expectedParticipantCounts: formatNumber(
                structure.expectedParticipantCount
              ),
            }
          )}
          percentage={toNumber(
            (structure.participantCount / structure.expectedParticipantCount) *
              100
          )}
        />
        {Object.keys(structure.sections).length > 1 && (
          <ChStPrt10
            points_text={t('challenge.COLab01.points')}
            activities_text={t('challenge.COLab01.activities')}
            participation_text={t('challenge.COLab01.participation')}
            tooltip_text={t('challenge.COLab01.your_status')}
            sectionKey={sectionKey}
            sections={structure.sections}
          />
        )}
      </StatsContainer>
      <Spa16 />
    </Wrapper>
  );
}

export default connect(deps, ParticipationInsights);
